import React from 'react'
import { THtmlElementHeading } from '@/types/HtmlElements'

interface CardHeadingInterface {
  (props: { children: React.ReactNode; tag: THtmlElementHeading }): JSX.Element
}

const CardHeading: CardHeadingInterface = ({ children, tag }) => {
  const Tag = tag

  return (
    <Tag className="flex items-center gap-2 text-lg font-semibold text-gray-1100">
      {children}
    </Tag>
  )
}

export default CardHeading
